import React from "react";

import { Container, Col, Row, Nav } from "react-bootstrap";
import { Helmet } from "react-helmet";

function blogContent(props) {
  return (
    <Container>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{props.blog.blogName}</title>
        <meta name="description" content={props.blog.blogName} />

        <link rel="canonical" href="http://shop.com/blog/" />
      </Helmet>

      <Row>
        <Col>
          <Nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>

              <li className="breadcrumb-item active">{props.blog.blogName}</li>
            </ol>
          </Nav>
        </Col>
      </Row>

      <div className="row product-detail-page">
        <div className="col-md-6">
          <h1 className="product-title">
            {" "}
            {props.blog.blogName} <p></p>{" "}
          </h1>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <dl>
            <dt></dt>
            <dd>
              <div
                dangerouslySetInnerHTML={{ __html: props.blog.blogContent }}
              />
            </dd>
          </dl>
        </div>
      </div>
    </Container>
  );
}

export default blogContent;
